import React, { Component } from 'react'
// import { Link } from 'gatsby'
// import { Nav, Image, Dropdown } from 'react-bootstrap'
import SideBar from 'react-sidebar'
import './menu.css'
import { Link } from 'gatsby'

export default class Menu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sidebarOpen: false,
      sidebarpullRight: true,
    }
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this)
  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open })
  }
  render() {
    return (
      <SideBar
        sidebar={
          <div className="navigation">
            <div className="sidebar-header header-cover">
              <img src="/img/logo_whites.png" alt="" />
            </div>
            <div>
              <ul className="list-unstyled d-flex main-nav flex-column mb-2">
                <li className="d-flex icon-svg">
                  <Link
                    to="/contact"
                    style={{
                      opacity: '1',
                      transform: 'matrix(1, 0, 0, 1, 0, 0)',
                    }}
                  >
                    <svg
                      style={{
                        width: '22px',
                        height: '34px',
                        marginRight: '6px',
                        marginBottom: '9px',
                      }}
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#7d7d7d"
                        d="M9,19V13H11L13,13H15V19H18V10.91L12,4.91L6,10.91V19H9M12,2.09L21.91,12H20V21H13V15H11V21H4V12H2.09L12,2.09Z"
                      ></path>
                    </svg>{' '}
                    Sell My Home{' '}
                  </Link>
                </li>
                <li className="d-flex">
                  <Link to="/#team">
                    <svg
                      style={{
                        width: '22px',
                        height: '34px',
                        marginRight: '6px',
                        marginBottom: '9px',
                      }}
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#7d7d7d"
                        d="M4.5,11A1.5,1.5 0 0,0 6,9.5A1.5,1.5 0 0,0 4.5,8A1.5,1.5 0 0,0 3,9.5A1.5,1.5 0 0,0 4.5,11M22.17,9.17C22.17,5.3 19.04,2.17 15.17,2.17A7,7 0 0,0 8.17,9.17C8.17,12.64 10.69,15.5 14,16.06V20H6V17H7V13A1,1 0 0,0 6,12H3A1,1 0 0,0 2,13V17H3V22H19V20H16V16.12C19.47,15.71 22.17,12.76 22.17,9.17Z"
                      ></path>
                    </svg>{' '}
                    Meet My Team{' '}
                  </Link>
                </li>
                <li className="d-flex">
                  <Link to="/blog-list">
                    <svg
                      style={{
                        width: '22px',
                        height: '28px',
                        marginRight: '6px',
                        marginBottom: '9px',
                      }}
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#7d7d7d"
                        d="M4.5,11A1.5,1.5 0 0,0 6,9.5A1.5,1.5 0 0,0 4.5,8A1.5,1.5 0 0,0 3,9.5A1.5,1.5 0 0,0 4.5,11M22.17,9.17C22.17,5.3 19.04,2.17 15.17,2.17A7,7 0 0,0 8.17,9.17C8.17,12.64 10.69,15.5 14,16.06V20H6V17H7V13A1,1 0 0,0 6,12H3A1,1 0 0,0 2,13V17H3V22H19V20H16V16.12C19.47,15.71 22.17,12.76 22.17,9.17Z"
                      ></path>
                    </svg>
                    Watch Our Videos{' '}
                  </Link>
                </li>
                <li className="d-flex">
                  <Link to="/contact">
                    <svg
                      style={{
                        width: '22px',
                        height: '28px',
                        marginRight: '6px',
                        marginBottom: '9px',
                      }}
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#7d7d7d"
                        d="M4,3A1,1 0 0,0 3,4A17,17 0 0,0 20,21A1,1 0 0,0 21,20V16.5A1,1 0 0,0 20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.17L13.21,17.37C10.38,15.93 8.06,13.62 6.62,10.78L8.82,8.57C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4A1,1 0 0,0 7.5,3H4M15,3V4.5H18.5L13,10L14,11L19.5,5.5V9H21V3H15Z"
                      ></path>
                    </svg>
                    Contact{' '}
                  </Link>
                </li>
                <li className="d-flex">
                  <Link to="/contact">
                    <svg
                      style={{
                        width: '24px',
                        height: '34px',
                        marginRight: '6px',
                        marginBottom: '9px',
                      }}
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#7d7d7d"
                        d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
                      ></path>
                    </svg>{' '}
                    Search Homes{' '}
                  </Link>
                </li>
              </ul>
              <div className="menu-social ml-2">
                <ul className="mb-0 ">
                  <li>
                    <a
                      href="https://www.facebook.com/ArmstrongRealEstateCompany/"
                      target="_blank"
                      className="hvr-pulse"
                      rel="noopener noreferrer"
                      style={{ opacity: '1' }}
                    >
                      <svg
                        style={{
                          width: '22px',
                          height: '24px',
                          display: 'inline-block',
                          margin: 'auto',
                        }}
                        viewbox="0 0 24 24"
                      >
                        <path
                          fill="#b7b7b7"
                          d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z"
                        ></path>
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="agentconts p-3">
                <div className="copyrightside text-left text-dark">
                  <p>Copyright 2019 Armstrong Real Estate Company</p>
                </div>
              </div>
            </div>
          </div>
        }
        open={this.state.sidebarOpen}
        onSetOpen={this.onSetSidebarOpen}
        pullRight={this.state.sidebarpullRight}
        styles={{
          sidebar: {
            background: '#ffffff',
            width: '300px',
            position: 'fixed',
            zIndex: '9999',
            height: '100%',
          },
          root: { position: 'relative', overflow: 'visible' },
          overlay: { backgroundColor: 'rgba(0, 0, 0, 0.65)' },
          content: {
            position: 'relative',
            overflow: 'visible',
            cursor: 'pointer',
          },
        }}
      >
        <div
          className="nav_content"
          onClick={() => this.onSetSidebarOpen(true)}
        >
          <h5 className="float-right nav_handle mb-0 ">
            <img src="/img/bars.svg" alt="bar" />
          </h5>
        </div>
      </SideBar>
    )
  }
}
